import React from 'react'

function footer() {
  return (
    <>
         <footer class="footer bg-black small text-center text-white-50"><div class="container px-4 px-lg-5">Copyright &copy; View na cafe 2024</div></footer>
    </>
  )
}

export default footer